import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {WaitingTimeContent} from "../Components/waitingTimeContent.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";

export function WaitingTimeInfo({setStep, closeModal}) {
    const storedTime = storage.get(STORAGE_KEYS.RIDE_TIME);
    const smartTimeValue = storedTime
        ? new Date(storedTime).toLocaleTimeString('en-US', {hour: 'numeric', minute: '2-digit'})
        : '';
    return (
        <>
            <ModalHeader title="" extraClasses="no-space" totalSteps={0} cancelButton={false} backStep="smartTimeSelect" showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <div className="hopn-waiting-time-info modalPages-spacing pb-8">
                <WaitingTimeContent
                    onAgree={() => setStep('travelingDateTime')}
                    onSelectSmartTime={() => setStep('travelingDateTime')}
                    smartTimeValue={smartTimeValue}
                />
            </div>
        </>
    );
}
export default WaitingTimeInfo;
